
const getElementOfRibbon = (ribbon) => {
  const auxRibbonId = ribbon.id.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase() || ''
  const auxIdCard = `${auxRibbonId}_${ribbon.type === "landscape" ? "classic" : ribbon.type}`;
  const number = ribbon.type === "highlight" ? 2 : 1;

  return `#${auxIdCard}_link_${number}`
};

export const getIdsRibbonsUpAndDownTalents = (ribbonsPrev) => {
  const ribbons = ribbonsPrev;
  let ribbonsUpId = "";
  let ribbonsDownId = "";

  const indexTalents = ribbons.findIndex((ribbon) => ribbon.type === 'tooncharacter');

  if (indexTalents !== -1) {
    const firstElement = ribbons.filter((ribbon, index) => index === indexTalents - 1);
    const secondElement = ribbons.filter((ribbon, index) => index >= indexTalents + 1 && ribbon.items.length > 0);

    if(firstElement.length > 0) {
      const ribbon = firstElement[0];
      ribbonsUpId = getElementOfRibbon(ribbon);
    };

    if(secondElement.length > 0) {
      const ribbon = secondElement[0];
      ribbonsDownId = getElementOfRibbon(ribbon);
    }

  }

  return { ribbonsUpId, ribbonsDownId };

}



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/utis.js